import { useState } from 'react';

export default function useControlState({ name, formIndex, defaultValue, dispatch, useBusEffectOn, hook }) {
  const [value, setValue] = useState(defaultValue);

  useBusEffectOn(`${formIndex}:${name}-set-state`, value => setValue(() => value));

  const handleOnChange = ({ value }) => {
    if (typeof hook === 'function') hook(value);
    dispatch(`${formIndex}-state-change`, { name, value });
    setValue(() => value);
  };

  return { value, handleOnChange };
}
